import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormErrors } from '../../inc/error-form';
// import ReplaceAllContent from '../../config/replace-all';
import { GetText, ReplaceInsText, ReplaceText } from '../../config/helper';
import MyCustomUploadAdapterPlugin from '../../inc/ckImageUploader';
import { FaCircleCheck, FaArrowRight } from 'react-icons/fa6';

const authKey = global.config.kindcode.training[22]+global.config.authBearerKey;
// const authKey2 = global.config.kindcode.training[3]+global.config.authBearerKey;

// function getCategoryList(type,usedfor) {
//     return new Promise((resolve) => {
//       var dataText ='{"keyword":"","pageShow":"10","usageFor":"'+usedfor+'","type":"'+type+'"}';
//     //   var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly","type":"'+type+'"}';
//       var dataSend = JSON.parse(dataText);
//       fetch(global.config.urlLink+"/categorylist", {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//           'Access-Control-Allow-Origin': '*',
//           'Authorization': authKey2
//         }, 
//         body : JSON.stringify(dataSend)
//       }).then(response => {
//         if(response.status === 200) {
//           return response.json();
//         } else {
//           console.log('Something happened wrong');
//         }
//       }).then(resultJson => {
//         if(resultJson.status === "200") {
//             console.log("Category");
//             console.log(resultJson.values);
//             if(resultJson.values.length > 0) {
//                 var result = resultJson.values.filter(ty => ty.content.categoryType.trim() === type.trim());
//                 resolve(result);  
//             } else {
//                 resolve([])
//             }
          
//         } else {
//           resolve([])
//         }
//       });
//     });
//   }

// async function getAllDatas(type,usedfor) {
//     const categoryresult = getCategoryList(type,usedfor);

//     const [thing1] = await Promise.all([categoryresult]);
//     var arrReturnValue = {};
//     arrReturnValue.categorylist = thing1;
//     return arrReturnValue;
// }

export default class DiscussionFormReply extends Component {
  constructor(props) {
    super(props);
    this.state = {
      action: '',
      // activePage: '',
      currentPage: '',
      member_id: localStorage.getItem('doc_id'),
      member_email: "",
      source: "",
      thread_id: "",
      thread_reply_id: "",
      thread_title: "",
      thread_category: "",
      thread_status: "",
      thread_type: "",
      thread_reply_description: "",
      // thread_category_list: [],
      formErrors: { thread_reply_description: ''},
      threadreplydescriptionValid: false,
      formValid: false,
      input_disabled: true,
      success_msg: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleUserCKEditorInput = (e) => {
    const name = "thread_reply_description";
    const value = e.getData();
    this.setState({[name]: value},
        () => { this.validateField(name, value)});
  }
  // handleUserInput = (e) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   this.setState({[name]: value},
  //       () => { this.validateField(name, value)});
  // }
  // handleUserSelect = (e) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   this.setState({[name]: value},
  //       () => { this.validateField(name, value)});
  // }
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let threadreplydescriptionValid = this.state.threadreplydescriptionValid;
    
    switch(fieldName) {
        case 'thread_reply_description': 
            threadreplydescriptionValid = value.trim().length > 0;
            fieldValidationErrors.thread_reply_description = threadreplydescriptionValid ? '' : 'your response need to be filled';
            break;
        default:
            break;
    }
    
    this.setState({formErrors: fieldValidationErrors,
                    threadreplydescriptionValid: threadreplydescriptionValid,
                }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: this.state.threadreplydescriptionValid });
  }

  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.thread_reply_description !== '' ) {
        document.getElementById('loading-area').style.display = 'block'; 
        var urlFetch, datatext;
        
        // if(this.textInputthreadDescription.value === '') { threadDescription = this.state.thread_description; } else { threadDescription = this.textInputthreadDescription.value; }
        var threadReplyDescription = ReplaceInsText(this.state.thread_reply_description);
            
        var urlFetch = global.config.urlLink;
        var datatext='{';
        datatext += '"thread_docid":"'+this.state.thread_id+'","threply_description":"'+threadReplyDescription+'"';
        // if(this.state.action === "edit") {
        if(this.state.thread_reply_id !== "") {
            datatext +=',"threply_id":"'+this.state.thread_reply_id+'","form_id":"form-editreply"';
            urlFetch +='/threadedit';
        } else {
            datatext +=',"threply_stat":"'+global.config.threadStatus[1]+'","form_id":"form-addreply"';
            urlFetch +='/threadadd';
        }
        datatext += '}'

        console.log(datatext);
        var data = JSON.parse(datatext);
        console.log(data)
        fetch(urlFetch, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
        }).then(res => {
            if(res.status === 200) 
                return res.json() 
        }).then( resJson => {
            if(resJson.status === '200') {
                var docId = resJson.values;
                this.setState({ 
                    thread_id: docId,
                    success_msg: true
                  });
                // window.location.href=global.config.urlCms+"/"+this.state.activelink;
                // window.location.href=global.ctconfig.urlHost+'/cteditdetailtutor/'+docId;
            } else {
                console.log('Something happened wrong');
            }

            document.getElementById('loading-area').style.display = 'none'; 
        }).catch(err => { 
            document.getElementById('loading-area').style.display = 'none'; 
        });
    
    } else {
        console.log("aaa")
        var arrfieldName = ['thread_reply_description'];
        var arrvalue = [this.state.thread_reply_description];
        for(var ck in arrfieldName) {
            this.validateField(arrfieldName[ck], arrvalue[ck]);
        }
    }
  }

  componentDidMount() {
    var content = this.props.value;
    // var data = {}; 
    // if(content.data !== undefined) { data = content.data; }
    // var promoType = global.config.specialCategory.filter(ty => ty.link.trim() === content.currpage.trim());
    // var promoTypeResult = promoType.length > 0? promoType[0].value : '';
    console.log("content");
    console.log(content);
    var replyid="",replydesc="";
    var replystat=global.config.threadStatus[1];
    // var data = {}; 
    // if(content.data !== undefined) { data = content.data; }
    if(content.data.subcontent !== undefined) {
      replyid=content.data.subdocid;
      replydesc=content.data.subcontent.replyMessage;
      replystat=content.data.subcontent.replyStatus;
    }
    
        this.setState({
          action: content.data.replyid !== undefined? 'edit' : 'add',
          // activePage: content.activepage,
          currentPage: content.currpage,
          // member_id: localStorage.getItem('doc_id'),
          // member_email: "",
          source: "discussion",
          thread_id: content.data.threadId,
          thread_reply_id: replyid,
          thread_title: content.data.threadTitle,
          thread_reply_status: replystat,
          thread_reply_description: replydesc,
          
          formErrors: { thread_reply_description: ''},
          input_disabled: false
        });

    // getAllDatas(promoTypeResult,"discussion").then((response) => {
    //     console.log("res");
    //     console.log(response)

    //     this.setState({
    //         action: data.id !== undefined? 'edit' : 'add',
    //         activePage: content.currpage,
    //         thread_category_list: response.categorylist,
    //         thread_id: data.id !== undefined? data.id : '',
    //         thread_title: data.threadSubject !== undefined? data.threadSubject : '',
    //         thread_description: data.threadDescription !== undefined? ReplaceText(data.threadDescription) : '',
    //         thread_category: data.threadCategoryId !== undefined? '{"id":"'+data.threadCategoryId+'","name":"'+data.threadCategoryName.trim()+'"}' : '',
    //         thread_status: data.threadStatus !== undefined? data.threadStatus : '',
    //         thread_type: data.threadType !== undefined? data.threadType : promoTypeResult,
    //         formErrors: { thread_title: '', thread_description: '', thread_category: '', thread_status: '', thread_type: ''},
    //         input_disabled: false
    //     });
    // });
  }

  render() {
    return (
        <div className="container mb-4">
          <div id="thread-form">
             {
                this.state.success_msg === true ? (
                    <div className="p-4 mb-5  w-100 d-flex justify-content-center"> 
                        <div className="row">
                          <div className="col-lg-2 d-flex justify-content-center">
                            <FaCircleCheck color="green" fontSize="80px" className="mt-2"/>
                          </div>
                          <div className="col-lg-10">
                            <div  className="mt-1 ms-2 fs-3">{GetText()? "Berhasil dikirim" : "Success submitted"}</div>
                            <div  className="mt-2 ms-2 fs-6">{GetText()? "Terima kasih, Anda telah berhasil memberikan tanggapan atas topik ini." : "Thank you, You've been successfully giving a feedback for this topic."} </div>
                            <div  className="mt-4 ms-2 fs-6">
                                <span className="link-more" onClick={() => window.location.href=global.config.urlHost+this.state.currentPage}>{GetText() ? "Kembali" : "Back"} <FaArrowRight/></span>
                            </div>
                          </div>
                        </div>
                  </div>  
                ) : (
                <>
                <div className="mt-1">
                    <p>
                      {GetText()? "Topik":"Topic"}<br/><span className='fs-6'>{this.state.thread_title}</span>
                    </p>
                </div>
                
                <div className="mt-4">
                    <div >
                    <form onSubmit={this.handleSubmit}>
                        <div className="mt-3">
                            <label htmlFor="thread_reply_description">{GetText()? "Tanggapan Anda " : "Your Response"}</label>
                            <div className="discussion-editor">
                                <CKEditor
                                    editor  = { ClassicEditor }
                                    name    = "thread_reply_description"
                                    data    = {this.state.thread_reply_description}
                                    config  = {{
                                      extraPlugins:[MyCustomUploadAdapterPlugin], 
                                      state: this.state, 
                                      key:authKey
                                    }}
                                    onReady = { editor => {
                                        // You can store the "editor" and use when it is needed.
                                        console.log( 'Editor is ready to use!', editor );
                                        editor.ui.view.editable.element.style.height = "300px";
                                    } }
                                    onChange={ ( event, editor ) => {
                                        this.handleUserCKEditorInput(editor);
                                        const data = editor.getData();
                                        
                                        //this.textInputContentLongDesc = data;
                                        console.log( { event, editor, data } );
                                        editor.ui.view.editable.element.style.height = "300px";
                                    } }
                                    onBlur={ ( event, editor ) => {
                                        console.log( 'Blur.', editor );
                                        editor.ui.view.editable.element.style.height = "300px";
                                    } }
                                    onFocus={ ( event, editor ) => {
                                        console.log( 'Focus.', editor );
                                        editor.ui.view.editable.element.style.height = "300px";
                                    } }
                                />
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.thread_reply_description}/>  }</div>
                            </div>
                        </div>
                        
                    
                        <div className="mt-4 mb-3">
                            <Button variant="primary" id="submit" type="submit" style={{ width: "100%", marginTop: "20px" }}>Submit</Button>
                        </div>
                    </form>
                    </div>
                </div>
                </>
                )
              }
                   
          </div>
          <div id="loading-area" className="d-none loading"></div> 
        </div>
    );
  }
}
